import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import {
    DisplayMessageMinimum,
    IStatusMessage,
    ResponseStatus
} from '../../shared';
import { ContractManagementService } from '../contract-management.service';
import * as FundingModActions from './funding-mod.actions';

@Injectable()
export class FundingModEffects {
    constructor(
        private actions$: Actions,
        private service: ContractManagementService
    ) {}

    getFundingMod$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FundingModActions.getFundingMod),
            switchMap(x =>
                this.service.getFundingMod(x.contract).pipe(
                    flatMap(resp => [
                        FundingModActions.loadFundingMods({
                            fundingMods: resp
                        }),
                        // new fromShared.Errors.RemoveErrors(
                        //     resp
                        //         .filter(
                        //             x =>
                        //                 x.Status.StatusCode ===
                        //                 ResponseStatus.Success
                        //         )
                        //         .map(x => x.FundingID.toString())
                        // ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putFundingMod$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FundingModActions.putFundingMod),
            switchMap(a =>
                this.service.putFundingMod(a.fundingMod).pipe(
                    flatMap(c => [
                        FundingModActions.upsertFundingMods({
                            fundingMods: c.Items
                        }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.FundingID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    deleteFundingMod$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FundingModActions.removeFundingMod),
            switchMap(a =>
                this.service.deleteFundingMod(a.ids).pipe(
                    flatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  FundingModActions.deleteFundingMods({
                                      ids: resp.Items.map(
                                          x => x.EntityID as string
                                      )
                                  })
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
